import {atomWithReset} from "jotai/utils";

export const abstractAtom = atomWithReset({
    title: '',
    authors: [],
    content: ''
})